<template>
	<vs-prompt
		@accept="shipOrderAccept"
		:active.sync="visible"
		title="Bestelling verzenden"
		acceptText="Verzend"
		cancelText="Annuleren">
		<form data-vv-scope="shippingForm">
			<div class="vx-row" v-if="order.order.sendcloud_parcel_id">
				<div class="vx-col w-full">
					<p class="text-sm">Deze bestelling heeft een SendCloud label.</p>
					<br>
					<p class="text-sm font-bold">Verzendmethode:</p>
					<p class="text-base">{{ order.order.sendcloud_method }}</p>
					<p class="text-sm font-bold">Track&trace:</p>
					<p class="text-base">{{ order.order.sendcloud_tracking }}</p>
					<vs-divider color="default" />
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col w-full">
					<label class="multiselect-label">Selecteer verzendmethode</label>
					<vue-multiselect
						v-validate="'required'"
						name="shippingMethod"
						placeholder="Selecteer verzendmethode"
						v-model="shippingMethod"
						:options="shipOptions"
						:show-labels="false"
						:allow-empty="false"
						track-by="name"
						label="name"
					/>
				</div>

				<div class="vx-col w-full">
					<vs-input class="w-full" label="Track & trace nummer" v-model="tracking" />
				</div>
			</div>
		</form>
	</vs-prompt>
</template>

<script>

import apiClient from '@/services/apiClient';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);
const messages = {
	custom: {
		shippingMethod: {
			required: 'Dit veld is verplicht',
		}
	}
};
Validator.localize('en', messages);

export default {
	components: {},
	props: {
		order: {
			type: Object,
			required: true,
		}
	},
	data() {
		return {
			visible: false,
			shippingMethod: null,
			tracking: '',
			shipOptions: [],
		}
	},
	watch: {
		'order.order.sendcloud_parcel_id'() {
			if (this.order.order.sendcloud_parcel_id && this.order.sendcloud_tracking) {
				this.tracking = this.order.sendcloud_tracking;
			}
		}
	},
	computed: {
		shippingOptions() {
			return this.$store.state.sendOptions.deliveryOptions;
		}
	},
	mounted() {
		for (const shippingOption in this.shippingOptions) {
			if (this.shippingOptions.hasOwnProperty(shippingOption)) {
				if (this.shippingOptions[shippingOption]) {
					this.shipOptions.push({
						name: this.getShippingOptionName(shippingOption),
						value: shippingOption
					})
				}
			}
		}

		if (this.order.order.sendcloud_parcel_id && this.order.order.sendcloud_tracking) {
			this.tracking = this.order.order.sendcloud_tracking;
		}
	},
	methods: {
		shipOrderAccept() {
			this.$validator.validateAll('shippingForm').then(result => {
				if (!result) {
					this.visible = true;

					this.$vs.notify({
						title: 'Oops!',
						text: 'Er zitten fouten in het formulier.',
						color: 'danger'
					});

					return;
				}

				const params = {
					order_id: this.order.order.id,
					ship: true,
					transporter_code: this.shippingMethod.value,
				};

				if (this.tracking !== '') {
					params.track_and_trace = this.tracking;
				}

				apiClient.put('orders/update', params).then(response => {

					this.$store.dispatch('openOrdersStore/updateOrder', response.data);

					if (response.data.order.status === 5) {
						setTimeout(
							() => {
								this.refreshOrderStatus()
							},
							1000
						);
					}
				}).catch(error => {
					this.$vs.notify({
						title: 'Oops!',
						text: 'Het verzenden van bestelling #' + this.order.order.type_id_visible + ' is mislukt',
						color: 'danger'
					});
				})
			});
		},
		refreshOrderStatus() {
			const params = {
				order_id: this.order.order.id,
			};

			apiClient.get('orders/get/order', {params}).then(response => {
				if (response.data.order.status === 5) {
					setTimeout(
						() => {
							this.refreshOrderStatus()
						},
						1000
					);

				} else {
					this.$store.dispatch('openOrdersStore/updateOrder', response.data);
				}
			}).catch(error => {

			});
		},
		getShippingOptionName(shippingOption) {
			const shippingOptions = {
				BRIEFPOST: 'Briefpost',
				UPS: 'UPS',
				TNT: 'PostNL',
				TNT_EXTRA: 'PostNL extra@home',
				TNT_BRIEF: 'PostNL Briefpost',
				TNT_EXPRESS: 'TNT Express',
				DYL: 'Dynalogic',
				DPD_NL: 'DPD Nederland',
				DPD_BE: 'DPD België',
				BPOST_BE: 'Bpost België',
				BPOST_BRIEF: 'Bpost Briefpost',
				DHLFORYOU: 'DHLFORYOU',
				GLS: 'GLS',
				FEDEX_NL: 'FedEx Nederland',
				FEDEX_BE: 'FedEx Belgie',
				OTHER: 'Anders',
				DHL: 'DHL',
				DHL_DE: 'DHL Germany',
				DHL_GLOBAL_MAIL: 'DHL Global mail',
				TSN: 'Transportservice Nederland',
				FIEGE: 'Fiege',
				TRANSMISSION: 'TransMission',
				PARCEL_NL: 'Parcel.nl',
				LOGOIX: 'LogoiX',
				PACKS: 'Packs',
				COURIER: 'Bezorgafspraak',
				RJP: 'NedWRK(Red je pakketje)',
			};

			return shippingOptions[shippingOption];
		},
	}
}
</script>

<style>
li.disabled {
	pointer-events: none;
}

li.disabled:hover {
	cursor: not-allowed;
}
</style>